module.exports = __webpack_public_path__ + "img/paros_de_emergencia.ffd5d348.jpg";